import styled, { css } from 'styled-components';

import colors from 'utils/colors';

import { ParagraphProps } from './interfaces';

const sharedStyles = css<ParagraphProps>`
  font-size: 1rem;
  line-height: 24px;
  letter-spacing: -0.3px;
  ${props => props.decoration && `text-decoration: ${props.decoration}`}
`;

export const Body = styled.p<ParagraphProps>`
  ${sharedStyles};
  font-weight: ${props => props.fontWeight || 'normal'};
  font-size: ${props => props.fontSize || '16'}px;
  text-align: ${props => props.textAlign || 'inherit'};
  color: ${props => (props.color ? colors[props.color] : colors.blueGrey)};
`;

export default Body;
